import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Home } from './pages/Home';
import { ServicePage } from './pages/ServicePage';
import { Enquiry } from './pages/Enquiry';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/services" element={<Navigate to="/#services" replace data-id="element-6" />} data-id="element-5" />
          <Route path="/services/:slug" element={<ServicePage data-id="element-8" />} data-id="element-7" />
          <Route path="/enquiry" element={<Enquiry data-id="element-10" />} data-id="element-9" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-12" />} data-id="element-11" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}